import awsconfig from "../aws-exports";

//Update this file later on. Currently, AWS Amplify does not support caching for S3. So, we are using cloudfront for cashing. This can be a security risk because people can access the S3 private folders with the cloudfront link.

interface ICloudFrontDomainNames {
    [key: string]: string;
}

const cloudFrontDomainNames: ICloudFrontDomainNames = {
    sandbox: "https://d2nmoln0sb0cri.cloudfront.net",
    dev: "https://d2nmoln0sb0cri.cloudfront.net",
    test: "https://d7g1r2w4ykupn.cloudfront.net",
    prod: "https://d1hfsnuz4i23pd.cloudfront.net",
};

export const getCloudFrontDomainName = () => {
    const envStart = awsconfig.aws_user_files_s3_bucket.lastIndexOf("-");
    const env = awsconfig.aws_user_files_s3_bucket.slice(envStart + 1);

    return cloudFrontDomainNames[env];
};

export const getPublicCloudFrontDomainName = () => {
    return "https://d30m4xw3xm7tyf.cloudfront.net";
};

interface IStripeAPIKey {
    [key: string]: string;
}

const stripAPIKeys: IStripeAPIKey = {
    sandbox: process.env.REACT_APP_STRIPE_TEST_KEY || "",
    dev: process.env.REACT_APP_STRIPE_TEST_KEY || "",
    test: process.env.REACT_APP_STRIPE_LIVE_KEY || "",
    prod: process.env.REACT_APP_STRIPE_LIVE_KEY || "",
};

export const getStripeAPIKey = () => {
    const envStart = awsconfig.aws_user_files_s3_bucket.lastIndexOf("-");
    const env = awsconfig.aws_user_files_s3_bucket.slice(envStart + 1);

    return stripAPIKeys[env];
};
